// import { Box, InputAdornment, Slider, TextField, Typography } from '@mui/material';
// import React from 'react';
// import { MoneyInputv3 } from './moneyFormatInput';

// const moneyInputStyle = {
//   minWidth: '80px',
//   fontSize: '12px',
//   textAlign: 'right',
//   padding: 0, // Set padding to 0
//   '& .MuiOutlinedInput-root': {
//     border: 'none', // Remove border
//     '& fieldset': {
//       border: 'none', // Remove the outline/border
//     },
//     padding: 0, // Remove padding inside the input
//   },
//   '.MuiInputBase-input': {
//     padding: 0, // Remove padding for the input text
//   },
//   '.MuiInputBase-root': {
//     fontSize: '12px',
//   },
//   label: {
//     fontSize: '12px',
//   },
//   '.MuiFormLabel-root': {
//     color: 'input.font',
//   },
//   '.MuiOutlinedInput-notchedOutline': {
//     borderColor: 'input.border',
//   },
//   '.MuiOutlinedInput-input': {
//     textAlign: 'right',
//     padding: 0, // Remove padding for input text
//   },
// };

// const MoneyRanger = ({ onChange = () => {}, min = 0, max = 0, maxValue = 0, minValue = 0, hideSlider = true, currencyType }) => {
//   const isDays = currencyType === 'Days';
//   console.log({ min, max, maxValue, minValue });
//   min = min === '' ? (minValue === maxValue ? 0 : minValue) : min;
//   max = max === '' ? maxValue : max;
//   console.log(maxValue);
//   const handleChange = (event, newValue, activeThumb) => {
//     // Prevent swapping of the values
//     if (min > max) {
//       if (activeThumb === 0) {
//         onChange([max, max]);
//       } else {
//         onChange([min, min]);
//       }
//     } else {
//       onChange(newValue);
//     }
//   };

//   const handleInputChange = (index) => (value) => {
//     const val = value === '' ? 0 : parseFloat(value);

//     let newValues = [min, max];

//     if (index === 0) {
//       newValues[0] = Math.min(val, newValues[1]); // Prevent the minimum from being more than the maximum
//     } else {
//       newValues[1] = Math.max(val, newValues[0]); // Prevent the maximum from being less than the minimum
//     }

//     onChange(newValues);
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         width: '90%',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//       }}
//     >
//       {!hideSlider && (
//         <Slider
//           value={[min ?? 0, max]}
//           onChange={handleChange}
//           valueLabelDisplay="auto"
//           disableSwap
//           defaultValue={1000}
//           min={minValue}
//           max={maxValue}
//           sx={{
//             padding: '0px',
//             paddingTop: '10px',
//             width: '90%',
//             height: '6px',
//             '& .MuiSlider-thumb': {
//               height: '12px',
//               width: '12px',
//               '& .MuiSlider-valueLabel': {
//                 fontSize: '10px',
//                 top: '-10px',
//               },
//               '&:before': {
//                 boxShadow: 'none',
//               },
//             },
//             '& .MuiSlider-rail': {
//               height: '4px',
//             },
//             '& .MuiSlider-track': {
//               height: '4px',
//             },
//             '.MuiSlider-thumb.Mui-focusVisible, .MuiSlider-thumb:hover': {
//               'box-shadow': 'none !important',
//             },
//           }}
//         />
//       )}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           width: '100%',
//         }}
//       >
//         {isDays ? (
//           <TextField
//             value={min}
//             onChange={(e) => handleInputChange(0)(e.target.value)}
//             size="small"
//         InputProps={{
//     endAdornment: (
//       <InputAdornment position="end" disablePointerEvents sx={{ m: 0, ml: 0.5 }}>
//         <Typography sx={{ fontSize: 11, lineHeight: 1, color: 'text.secondary' }}>
//           Days
//         </Typography>
//       </InputAdornment>
//     ),
//   }}
//             inputProps={{ 'aria-label': 'min days', min: 0, step: 1, style: { padding: '0 5px', textAlign: 'left' } }}
//              onInput={(e) => {
//               e.target.value = e.target.value.replace(/[^0-9]/g, '');
//               if (e.target.value.startsWith('0') && e.target.value.length > 1) {
//                 e.target.value = e.target.value.replace(/^0+/, '');
//               }
//             }}
//             sx={{
//               '& .MuiOutlinedInput-notchedOutline': {
//                 border: 'none',
//               },
//               minWidth: `${Math.max(9, String(min).length + 8)}ch`,
//             }}
//           />
//         ) : (
//           <MoneyInputv3
//             state={min}
//             currencyType={currencyType}
//             onChange={handleInputChange(0)}
//             sx={{ ...moneyInputStyle, minWidth: `${Math.max(12, String(min).length + 11)}ch` }}
//             inputProps={{ 'aria-label': 'min value', style: { padding: '0 5px' } }}
//           />
//         )}
//         <span style={{ margin: '0 8px' }}>to</span>
//         {isDays ? (
//           <TextField
//             value={max}
//             onChange={(e) => handleInputChange(1)(e.target.value)}
//             size="small"
//        InputProps={{
//     endAdornment: (
//       <InputAdornment position="end" sx={{ ml: 0.5 }}>
//         <Typography variant="caption" sx={{ fontSize: '11px', color: 'text.secondary' }}>
//           Days
//         </Typography>
//       </InputAdornment>
//     ),
//   }}
//             inputProps={{
//               'aria-label': 'max days',
//               min: 0,
//               step: 1,
//               style: { padding: '0 5px', textAlign: 'left' },
//             }}
//             onInput={(e) => {
//               e.target.value = e.target.value.replace(/[^0-9]/g, ''); // remove non-digits
//               if (e.target.value.startsWith('0') && e.target.value.length > 1) {
//                 e.target.value = e.target.value.replace(/^0+/, ''); // remove leading zeros
//               }
//             }}
//             sx={{
//               '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
//               minWidth: `${Math.max(12, String(max).length + 11)}ch`,
//             }}
//           />
//         ) : (
//           <MoneyInputv3
//             state={max}
//             currencyType={currencyType}
//             onChange={handleInputChange(1)}
//             sx={{ ...moneyInputStyle, minWidth: `${Math.max(8, String(max).length + 7)}ch` }}
//             inputProps={{ 'aria-label': 'max value', style: { padding: '0 5px', textAlign: 'right' } }}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default MoneyRanger;
import { Box, InputAdornment, Slider, TextField, Typography } from '@mui/material';
import React from 'react';
import { MoneyInputv3 } from './moneyFormatInput';

const moneyInputStyle = {
  minWidth: '80px',
  fontSize: '12px',
  textAlign: 'right',
  padding: 0,
  '& .MuiOutlinedInput-root': {
    border: 'none',
    '& fieldset': { border: 'none' },
    padding: 0,
  },
  '.MuiInputBase-input': { padding: 0 },
  '.MuiInputBase-root': { fontSize: '12px' },
  label: { fontSize: '12px' },
  '.MuiFormLabel-root': { color: 'input.font' },
  '.MuiOutlinedInput-notchedOutline': { borderColor: 'input.border' },
  '.MuiOutlinedInput-input': { textAlign: 'right', padding: 0 },
};

const parseNum = (v) =>
  v === '' || v === null || v === undefined || isNaN(Number(v)) ? null : Number(v);

const digitsLen = (v) => String(v ?? '').length;

const MoneyRanger = ({
  onChange = () => {},
  min = '',
  max = '',
  maxValue = 0,
  minValue = 0,
  hideSlider = true,
  currencyType,
}) => {
  const isDays = currencyType === 'Days';

  // For slider visualization
  const curMin = parseNum(min) ?? minValue;
  const curMax = parseNum(max) ?? maxValue;

  const clampIfBothNumbers = (left, right, idx) => {
    const a = parseNum(left);
    const b = parseNum(right);

    if (a === null || b === null) return [left, right];

    if (idx === 0) {
      return [Math.min(a, b), b];
    } else {
      return [a, Math.max(b, a)];
    }
  };

  const handleChangeSlider = (_event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) return;
    const [sMin, sMax] = newValue;

    if (activeThumb === 0) {
      onChange(clampIfBothNumbers(sMin, max === '' ? sMax : max, 0));
    } else {
      onChange(clampIfBothNumbers(min === '' ? sMin : min, sMax, 1));
    }
  };

  // const handleInputChange = (index) => (value) => {
  //   const valStr = String(value);
  //   const isEmpty = valStr.trim() === '';
  //   const val = isEmpty ? '' : Number(valStr);

  //   if (index === 0) {
  //     const [nMin, nMax] = clampIfBothNumbers(val, max, 0);
  //     onChange([nMin, nMax]);
  //   } else {
  //     const [nMin, nMax] = clampIfBothNumbers(min, val, 1);
  //     onChange([nMin, nMax]);
  //   }
  // };
  const handleInputChange = (index) => (value) => {
  const valStr = String(value);
  const isEmpty = valStr.trim() === '';
  const val = isEmpty ? '' : Number(valStr);

  if (index === 0) {
    // No clamping: just set min as typed
    onChange([val, max]);
  } else {
    // No clamping: just set max as typed
    onChange([min, val]);
  }
};


  return (
    <Box sx={{ display: 'flex', width: '90%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      {!hideSlider && (
        <Slider
          value={[curMin, curMax]}
          onChange={handleChangeSlider}
          valueLabelDisplay="auto"
          disableSwap
          min={minValue}
          max={maxValue}
          sx={{
            padding: '0px',
            paddingTop: '10px',
            width: '90%',
            height: '6px',
            '& .MuiSlider-thumb': {
              height: '12px',
              width: '12px',
              '& .MuiSlider-valueLabel': { fontSize: '10px', top: '-10px' },
              '&:before': { boxShadow: 'none' },
            },
            '& .MuiSlider-rail': { height: '4px' },
            '& .MuiSlider-track': { height: '4px' },
            '.MuiSlider-thumb.Mui-focusVisible, .MuiSlider-thumb:hover': { 'box-shadow': 'none !important' },
          }}
        />
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        {isDays ? (
          <TextField
            value={min}
            onChange={(e) => handleInputChange(0)(e.target.value)}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" disablePointerEvents sx={{ m: 0, ml: 0.5 }}>
                  <Typography sx={{ fontSize: 11, lineHeight: 1, color: 'text.secondary' }}>Days</Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{
              'aria-label': 'min days',
              min: 0,
              step: 1,
              style: { padding: '0 5px', textAlign: 'left' },
            }}
            onInput={(e) => {
              const raw = e.target.value;
              if (raw === '') return;
              let cleaned = raw.replace(/[^0-9]/g, '');
              if (cleaned.startsWith('0') && cleaned.length > 1) cleaned = cleaned.replace(/^0+/, '');
              e.target.value = cleaned;
            }}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              minWidth: `${Math.max(9, digitsLen(min) + 8)}ch`,
            }}
          />
        ) : (
          <MoneyInputv3
            state={min}
            currencyType={currencyType}
            onChange={handleInputChange(0)}
            sx={{ ...moneyInputStyle, minWidth: `${Math.max(12, digitsLen(min) + 11)}ch` }}
            inputProps={{ 'aria-label': 'min value', style: { padding: '0 5px' } }}
          />
        )}

        <span style={{ margin: '0 8px' }}>to</span>

        {isDays ? (
          <TextField
            value={max}
            onChange={(e) => handleInputChange(1)(e.target.value)}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ ml: 0.5 }}>
                  <Typography variant="caption" sx={{ fontSize: '11px', color: 'text.secondary' }}>
                    Days
                  </Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{ 'aria-label': 'max days', min: 0, step: 1, style: { padding: '0 5px', textAlign: 'left' } }}
            onInput={(e) => {
              const raw = e.target.value;
              if (raw === '') return;
              let cleaned = raw.replace(/[^0-9]/g, '');
              if (cleaned.startsWith('0') && cleaned.length > 1) cleaned = cleaned.replace(/^0+/, '');
              e.target.value = cleaned;
            }}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              minWidth: `${Math.max(12, digitsLen(max) + 11)}ch`,
            }}
          />
        ) : (
          <MoneyInputv3
            state={max}
            currencyType={currencyType}
            onChange={handleInputChange(1)}
            sx={{ ...moneyInputStyle, minWidth: `${Math.max(8, digitsLen(max) + 7)}ch` }}
            inputProps={{ 'aria-label': 'max value', style: { padding: '0 5px', textAlign: 'right' } }}
          />
        )}
      </Box>
    </Box>
  );
};

export default MoneyRanger;
